import React from 'react'
import { Row, Col, Button, Tooltip } from 'antd'
import { PaperClipOutlined, DownloadOutlined } from '@ant-design/icons'
import { AeroModal } from '../../../../AeroComponents'

 function AdditionalDataModal(props) {

    // extract props
    const {
        additionalDataModal, closeAdditionalDataModal, additionalData,  downloadAdditionalData // props from parent
    } = props

    return (
        <AeroModal bodyStyle={{ background: '#F5F5F5' }} title='Additional Data' visible={additionalDataModal} onCancel={closeAdditionalDataModal} footer={false}>
            <p>
                {additionalData?.description ? additionalData.description : ''}
            </p>
            <p>
                {
                    additionalData?.files.length > 0 ? 
                    additionalData.files.map((file, index) => (
                        <Row key={index} style={{marginBottom:'10px'}}>
                            <Col span={8}><PaperClipOutlined style={{ position: 'relative', bottom: '3px', color: 'grey' }} />
                                <Tooltip placement='top' title={file.fileName}>
                                        {file.fileName.length <= 15 ? file.fileName : file.fileName.substring(0, 15) + '...'}
                                </Tooltip>
                            </Col>
                            <Col span={8} offset={8}><Button onClick={()=>downloadAdditionalData(file.id)} type='link'><DownloadOutlined style={{ position: 'relative', bottom: '3px'}} />Download</Button></Col>
                        </Row>
                    )) : ''
                }
                
            </p>
        </AeroModal>
    )
}




export default AdditionalDataModal
